import { curry, isStr } from 'lib/util'
import temperatureUnits from '@model/xEcoApm/collection/temperatureUnit'

/**
 * Returns the list of available temperature units.
 *
 * @param module      current module
 * @param component   event source
 * @param eventOrKey  triggered event or temperatureUnit key
 * @returns the list of temperature units
 */
const listTemperatureUnits = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  eventOrKey: Gaia.PlatformEvent | string,
): { key: string, value: string }[] => {
  const key = isStr(eventOrKey) ? eventOrKey : eventOrKey?.detail?.key

  return key ? temperatureUnits.filter(item => item.key === key) : temperatureUnits
}

export default curry(listTemperatureUnits)
